module.exports = __webpack_public_path__ + "static/chara-db98ed6141db620283c30a1a1a7f6f4c.png";